import { Typography, Divider, CircularProgress } from '@material-ui/core'
import InfiniteScroll from 'react-infinite-scroller'

import { gregorianToJalaaliWithHourMinuteAndSecond } from '../../../../helpers/date'
import { getTranslate, lang } from '../../../../localization'
import { CRSStatus, PMSStatus } from '../../../../types/booking'
import { BookingDetail } from '../../../../types/bookingDetails'
import StatusBox from '../../../BookingList/StatusBox'
import { useStyles } from './styles/index.styles'

type Props = {
  bookingHistories: BookingDetail[]
  loadingForBookingHistory: boolean
  setPage: React.Dispatch<React.SetStateAction<number>>
  page: number
  perPage: number
  total: number
  adminEditMode: boolean
}
export default function HistoryTable({
  bookingHistories,
  loadingForBookingHistory,
  page,
  setPage,
  total,
  perPage,
  adminEditMode
}: Props) {
  const classes = useStyles()
  return (
    <div
      className={[
        classes.container,
        adminEditMode ? classes.adminRoot : ''
      ].join(' ')}>
      <div className={classes.header}>
        <Typography variant="h4" className={classes.blackText}>
          {getTranslate('History Table')}
        </Typography>
      </div>
      <Divider className={classes.divider} />
      <div className={classes.bottom}>
        <div className={classes.table}>
          <div className={classes.tableHead}>
            <Typography variant="h6" className={classes.cell}>
              #
            </Typography>
            <Typography variant="h6" className={classes.cell}>
              {getTranslate('Created At')}
            </Typography>
            <Typography variant="h6" className={classes.cell}>
              {getTranslate('Version')}
            </Typography>
            <Typography variant="h6" className={classes.cell}>
              {getTranslate('CRS Status')}
            </Typography>
            <Typography variant="h6" className={classes.cell}>
              {getTranslate('PMS Status')}
            </Typography>
          </div>
          {loadingForBookingHistory ? (
            <div className={classes.loadingContainer}>
              <CircularProgress size={32} />
            </div>
          ) : (
            <InfiniteScroll
              pageStart={0}
              loadMore={() => {
                setTimeout(() => {
                  setPage(page + 1)
                }, 2000)
              }}
              hasMore={perPage * page < total}
              loader={
                <div key={0} className={classes.loadingContainer}>
                  <CircularProgress size={32} />
                </div>
              }
              useWindow={true}>
              {bookingHistories.map((item, index) => (
                <div
                  key={index}
                  className={[
                    classes.row,
                    index % 2 !== 0 && classes.greyRow
                  ].join(' ')}>
                  <Typography variant="caption" className={classes.cell}>
                    {index}
                  </Typography>
                  <Typography variant="caption" className={classes.cell}>
                    {lang === 'en'
                      ? item.basicDetails.createdAt
                      : gregorianToJalaaliWithHourMinuteAndSecond(
                          item.basicDetails.createdAt
                        )}
                  </Typography>
                  <Typography variant="caption" className={classes.cell}>
                    {item.basicDetails.version}
                  </Typography>
                  <div>
                    <StatusBox
                      status={item.basicDetails.crsStatus as CRSStatus}
                    />
                  </div>
                  <div>
                    <StatusBox
                      status={item.basicDetails.pmsStatus as PMSStatus}
                    />
                  </div>
                </div>
              ))}
            </InfiniteScroll>
          )}
        </div>
      </div>
    </div>
  )
}
